import { AccountModelExt } from "@GeriMed/Type/ApiModelsExt";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { DashboardPanelCollectionModel } from "@insite/client-framework/Types/ApiModels";

const dashboardPanelUrl = "/api/v1/dashboardpanels/";

export async function getDashboardPanels(): Promise<DashboardPanelCollectionModel> {
    const result = await get<DashboardPanelCollectionModel>(dashboardPanelUrl);
    return result;
}
